import BoxContainer from '../../core/components/box/boxContainer';
import klabPoster from '../../../assets/klab.png';

const KlabPoster = (props: { width?: string; height?: string }) => {
  return (
    <BoxContainer padding="0" width={props.width} height={props.height}>
      <img src={klabPoster} alt="klab-poster"></img>
    </BoxContainer>
  );
};
export default KlabPoster;
